import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './SignupForm.css'
import config from '../../config'
import { LinkIcon } from '../../components'

@CSSModules(Styles)
export default class SignupForm extends Component {
  static propTypes = {
  }
  constructor(props){
    super(props)
  }

  componentDidUpdate() {
    this.myFormRef.reset();
  }

  render() {
    return (
      <div styleName='signup-background'>
        <div styleName='signup-container'>
          <div styleName='signup-container-inner'>
            <div styleName='signup-wrap'>
              <div styleName='form-wrap'>
                <form styleName='form'
                  acceptCharset='UTF-8'
                  method='post'
                  action={config.signupForm.url}
                  target='signup_confirmation'
                  ref={(el) => this.myFormRef = el}>
                  <div styleName='tagline'>
                    Stay connected
                  </div>
                  <input styleName='input'
                    name={config.signupForm.id}
                    type='email'
                    placeholder='Get email updates'
                    required />
                  <div style={{
                    position: 'absolute',
                    left: '-9999px',
                    top: '-9999px',
                  }}>
                    <label htmlFor="pardot_extra_field">Comments</label>
                    <input type="text" id="pardot_extra_field" name="pardot_extra_field" />
                  </div>
                  <button styleName='submit'
                    type='submit'
                    value=''>
                    Sign up<LinkIcon faclass='fa-envelope-o'/>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
